<template>
    <div>
        <v-row class="page-container mb-3 px-0 mt-4 hidden-sm-and-up">
            <h4 class="textColor fs-16">{{ $t('Список ПУТЭ') }}</h4>
        </v-row>
        <MetersTable />
    </div>
</template>

<script>
import MetersTable from '../../../components/servorgs/meters/MetersTable';
export default {
    components: {
        MetersTable
    },
    computed: {
        metersListFilter: {
            get() {
                return this.$store.state.meters.metersListFilter;
            },
            set(value) {
                this.$store.commit('meters/setMetersListFilter', value);
                // this.metersListPagination = {};
            }
        }
        // metersListPagination: {
        //     get() {
        //         return this.metersListOptions.pagination;
        //     },
        //     set(value) {
        //         this.metersListOptions.pagination = value;
        //     }
        // }
    },
    async beforeRouteLeave(to, from, next) {
        if (to.name !== 'MeterIndications') {
            this.metersListFilter = {};
            next();
        } else {
            next();
        }
    }
};
</script>

<style></style>
